import * as React from 'react'
import Loader from './Loader';
import FadeIn from '../Animations/FadeIn';
import './CheckoutLoader.css'
interface CheckoutLoaderProps {
  message?: string | React.JSX.Element;
  disable?:boolean;
}

export function CheckoutLoader({ message = "Laddar...",disable }: CheckoutLoaderProps) {
  return (
    <FadeIn>
    <div className="checkout-loader-container">
      <div className="checkout-loader-relative">
        <div /*className="absolute inset-0 rounded-full bg-primary/20 blur-xl animate-pulse-glow" *//>
        {!disable &&<Loader loaderSize='XLARGE' bgColor='#F39E60'/>}
      </div>
      {typeof message === 'string' ? (
          <p className="checkout-loader-text">{message}</p>
      ) : (
        message
      )
    }
      
      <div className="checkout-loader-flex">
        <div className="my-dot" />
        <div className="my-dot-2" />
        <div className="my-dot-3" />
      </div>
    </div>
    </FadeIn>
  );
}
